module.exports = __webpack_public_path__ + "img/logo_FRONTIER.19fcedff.png";